<template>
	<component :is="tag" class="metrics__metric--number">
		<dt class="metrics__metric__title" v-html="title"/>
		<dd class="metrics__metric__value">
			<dl>
				<dt class="sr-only">Number</dt>
				<dd class="metrics__metric__value__amount" v-html="tweenedValue"/>
				<dd v-if="link">
					<AppLink :to="link">{{ linkText }}</AppLink>
				</dd>
			</dl>
		</dd>
	</component>
</template>
<script>
export default {
	name: "AppMetricNumber",

	data() {
		return {
			tweenedValue: 0,
		};
	},

	props: {
		tag: {
			type: String,
			required: false,
			default() {
				return "dl";
			},
		},
		title: {
			type: String,
			required: false,
			default() {
				return null;
			},
		},
		amount: {
			required: false,
			type: Number,
			default() {
				return null;
			},
		},
		link: {
			required: false,
			type: Object,
			default() {
				return null;
			},
		},
		linkText: {
			required: false,
			type: String,
			default() {
				return "view";
			},
		},
	},

	methods: {
		tween(start, end) {
			let frameHandler;

			// Handles updating the tween on each frame.
			const animate = function (currentTime) {
				window.tween.update(currentTime);
				frameHandler = requestAnimationFrame(animate);
			};

			const myTween = new window.tween.Tween({tweeningValue: start})
				.to({tweeningValue: end}, 750)
				.easing(window.tween.Easing.Quintic.Out)
				// Be careful to not to do too much here! It will slow down the app.
				.onUpdate((tween) => {
					this.tweenedValue = tween.tweeningValue.toFixed(this.round);
					if (this.round) {
						let parts = this.tweenedValue.split(".");
						let decimal = parseInt(parts[1]);
						if (!decimal) {
							this.tweenedValue = parseInt(parts[0]);
						}
					}
				})
				.onComplete(() => {
					// Make sure to clean up after ourselves.
					cancelAnimationFrame(frameHandler);
				})
				// This actually starts the tween.
				.start();

			frameHandler = requestAnimationFrame(animate);
		},
	},

	mounted() {
		setTimeout(function () {
			this.tween(0, this.amount || 0);
		}.bind(this), 500);
	},
};
</script>
